module.exports = __webpack_public_path__ + "img/12-r.020dd366.png";